// "Missed IVR" calls: the CDR's isMissed flag, stored by the backend as is_missed_ivr
// (false when the CDR didn't send it). Not the same as calls.is_missed, which means the
// agent missed the call — never read that here. Read like Pseudo CDR (pseudoCdr.ts):
// booleans, 1/0 and "true"/"false" strings all work.

type MaybeMissedRow = { is_missed_ivr?: unknown } | null | undefined;

export const isMissedIvrRow = (row: MaybeMissedRow): boolean => {
  const raw = row?.is_missed_ivr;
  if (raw === true) return true;
  if (raw === false || raw === null || raw === undefined || raw === '') return false;
  const normalized = String(raw).trim().toLowerCase();
  return normalized === '1' || normalized === 'true' || normalized === 'yes';
};

/** "Yes" / "No" for exports and detail rows. */
export const missedIvrLabel = (row: MaybeMissedRow): string => (isMissedIvrRow(row) ? 'Yes' : 'No');

export const MISSED_IVR_LABEL = 'Missed IVR';
export const MISSED_IVR_TITLE = 'Missed IVR — the caller left during the IVR, before reaching an agent';
